<div class="header">
  <h1 class="title">{{title}}</h1>
  <div class="close-button">
    <em (click)="onClose()" class="fa fa-times pointer"></em>
  </div>
</div>

<div class="content">
  <div class="stepper" *ngIf="!onlyContract">
    <div class="step">
      <div class="number orange">
        <span> 1 </span>
      </div>
      <span class="text text-blue">Opções de carência</span>
    </div>
    <hr [class]="stepperStatus === 2 ? 'orange' : 'grey'" />
    <div class="step">
      <div [class]="stepperStatus === 2 ? 'number orange' : 'number grey'">
        <span> 2 </span>
      </div>
      <span [class]="stepperStatus === 2 ? 'text text-blue' : 'text text-grey'"
        >Assinatura digital</span
      >
    </div>
  </div>

  <div *ngIf="midMessage && !onlyContract" class="mid-message">
    <span>{{ midMessage }}</span>
  </div>

  <div *ngIf="display === 'single'">
    <app-single-approval
    [opcoesPagamento]="contratos[0].opcoesPagamento"
    (selectedIndex)="selectIndex($event)"
    ></app-single-approval>
  </div>

  <div *ngIf="display === 'multi'">
    <app-multi-approval
    [contratos]="contratos"
    [optionIndexes]="optionIndexes"
    ></app-multi-approval>
  </div>

  <!-- Contrato -->
  <div *ngIf="display === 'contrato'">
    <div class="row">
      <div class="col-xs-12 text-modal text-center">
        <iframe
          title="Contrato"
          [src]="sanitize(pdf)"
          class="w-100"
          [ngStyle]="{ 'height.vh': !onlyContract ? 60 : 80 }"
        ></iframe>
      </div>
    </div>
  </div>
</div>

<div *ngIf="display === 'multi-confirm'">
  <div class="row">
    <div class="col-xs-12 text-modal text-center">
      <span class="warning">Atenção</span>
      <span class="icon cessao-documento-assinar"></span>
      <h4>
        Deseja assinar digitalmente e aprovar a cessão de crédito dos
        <strong>
          {{ contratos.length }}
          Termos de Cessão selecionados</strong
        >?
      </h4>
    </div>
  </div>
</div>

<div class="continue-btn" *ngIf="!onlyContract">
  <button (click)="onAction()" class="btn btn-full-orange">
    {{ buttonLabel }}
    <em class="fa fa-arrow-right"></em>
  </button>
</div>

<app-loader-circles *ngIf="showLoader"></app-loader-circles>
